module.exports = __webpack_public_path__ + "img/Geza_Nagy.750902a8.jpg";